import { toast } from "react-toastify";
import { axios } from "../../utils/axios";
import { toastOptions } from "../../config/toast";

export const getCamaras = async (setCamaras) => {
  setCamaras((prevState) => ({
    ...prevState,
    filtrar_por_fecha: false,
    fecha_inicio: null,
    fecha_fin: null,
    is_loading: true,
  }));

  const result = await axios().get("/camaras");

  const { data, error } = result.data;

  if (data) {
    setCamaras((prevState) => ({
      ...prevState,
      is_loading: false,
      data: result.data.data,
    }));
  }
  if (error) {
    toast.error(error, toastOptions);
  }
};
